import { Button } from '@material-ui/core'
import React from 'react'
import './Dashboard.css'
import SideNav from './SideNav'
import { useHistory } from 'react-router-dom'

const DashboardLayout = (props) => {
    const history = useHistory()
    return (
        <div className="dashboard">
            <div className="customContainer">
                <div className="d-flex justify-content-start">
                    <div className="dashboardLt">
                        <SideNav />
                    </div>
                    <div className="dashboardRt">
                        <div className="maTitle d-flex justify-content-between align-items-center w-100 mb-3">
                            <h2 className="dashTitle">
                                {props.title}
                                {props.labelInfo ? (
                                    <span
                                        className="material-icons pointer info-label blacked-info"
                                        onClick={() => {
                                            props.function(true)
                                        }}
                                    >
                                        info
                                    </span>
                                ) : null}
                            </h2>

                            <Button
                                id="dashboard_back"
                                onClick={() => {
                                    history.goBack()
                                    window.scrollTo(0, 0)
                                }}
                                className="moveBack"
                            >
                                <span className="material-icons">arrow_back</span>
                                {'back'}
                            </Button>
                        </div>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardLayout
